// "The Neolithic API"

import { GraphQLClient } from 'graphql-request';
import { QueryClient } from '@tanstack/query-core';
import { getSdk } from './generated/gql-api.generated';
import { queryConfig } from '@/src/utils/cache/queryConfig';

const gqlClient = new GraphQLClient(
  process.env.NEXT_PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT!,
  {
    headers: {
      'x-api-key': process.env.NEXT_PUBLIC_AWS_APPSYNC_APIKEY!,
    },
    responseMiddleware: (response) => {
      if (!(response instanceof Error) && response.status === 200) {
        return response.data;
      }

      return response;
    },
  }
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      ...queryConfig,
    },
  },
});

export const {
  getUserByEmail, // used in one location: src/app/(client)/[name]/dashboard/layout.tsx
  getAllChatMessagesForEventChat, // confusion over imports from API version, location: src\app\(client)\[name]\event\[id]\page.tsx:
  getAllChatMessagesForKlicChat, // confusion over imports from API version. location: src\app\(client)\[name]\event\[id]\page.tsx:
} = getSdk(gqlClient);

/*
 * TODO: We should be using `React.cache()` to make a request-scoped singleton out of queryClient. Unfortunately,
 * currently it's not supported because we get a "Not implemented" error during build time.
 */
export const getQueryClient = () => queryClient;
